import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routeNames'

const splittestingRoutes: RouteRecordRaw[] = [
  {
    path: 'split-tests',
    name: ROUTES.SPLIT_TESTS,
    component: () => import('./pages/SplitTestsIndex.vue'),
    meta: {
      title: 'A/B Testing',
      description: 'Test questions, offers, and forms to increase conversions.'
    }
  }
]

export default splittestingRoutes
